import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowRight, Users, FolderOpen } from "lucide-react";
import { api } from "../lib/api";
import { usePageDescription } from "../lib/usePageDescription";
import PageHero from "../components/PageHero";

const badgeImg = (code) => `https://images.habbo.com/c_images/album1584/${code}.gif`;

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const pd = usePageDescription("projekte", {
    title: "Habbo.de Projekte & Teams",
    intro: "Hinter Habbo.de stecken viele engagierte Habbos – von Botschafter:innen über HabboEvents bis hin zu den Community Games. Hier findest du alle Projekte mit ihren Mitgliedern.",
  });

  useEffect(() => {
    (async () => {
      try {
        const data = await api.listProjects();
        setProjects(data);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <section className="mx-auto max-w-7xl px-4 py-10">
      <PageHero eyebrow={pd.eyebrow || "Projekte"} icon={FolderOpen} title={pd.title} keywords={pd.keywords} intro={pd.intro} />

      {loading ? (
        <div className="flex items-center justify-center py-20 text-zinc-400">
          <Loader2 className="h-5 w-5 animate-spin" />
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
          {projects.map((p) => {
            const code = (p.badge_code || "").trim();
            const color = p.badge_color || "#7c4dff";
            return (
              <Link
                key={p.id}
                to={`/projekte/${p.slug}`}
                className="card-hover group rounded-xl border border-white/10 bg-[#0f141b] p-5 block"
                data-testid={`project-card-${p.slug}`}
              >
                <div className="flex items-start gap-4">
                  <div
                    className="relative flex h-14 w-14 shrink-0 items-center justify-center rounded-lg border border-white/10 bg-[#0a0d12]"
                    style={{ boxShadow: `0 0 18px ${color}55, inset 0 0 12px ${color}33` }}
                  >
                    {code ? (
                      <img
                        src={badgeImg(code)}
                        alt={code}
                        className="h-10 w-10 object-contain"
                        style={{ imageRendering: "pixelated", filter: `drop-shadow(0 0 6px ${color}aa)` }}
                        loading="lazy"
                        onError={(e) => { e.currentTarget.style.display = "none"; }}
                        data-testid={`project-badge-${p.slug}`}
                      />
                    ) : (
                      <Users className="h-5 w-5 text-[#b39bff]" />
                    )}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-white group-hover:text-[#b39bff] transition-colors">{p.title}</h3>
                    <p className="mt-1 text-sm text-zinc-400">{p.description}</p>
                    <div className="mt-3 flex items-center justify-between">
                      <span className="text-xs text-[#9d7bff]">{(p.members || []).length} Mitglieder</span>
                      <span className="inline-flex items-center gap-1 text-xs text-zinc-400 group-hover:text-white">
                        Anzeigen <ArrowRight className="h-3.5 w-3.5" />
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default Projects;
